import { render } from "./BussinessStatistics.vue?vue&type=template&id=c5ac3eba&ts=true"
import script from "./BussinessStatistics.vue?vue&type=script&lang=ts"
export * from "./BussinessStatistics.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__